import React from 'react';
import templates from './codeTemplates.json';
import { ChartingCodeProvider } from 'pages/Test/lib/chartingCodeContext';
import { Grid } from '@mui/material';
import ChartingCodeDebug from './ChartingCodeDebug';
import CodeLayoutTypeSelector from 'pages/Test/CodeRenderers/CodeLayoutTypeSelector';



export const CodeRenderer = ({ templateName }) => {
	const template = templates[ templateName ];

	return (
		<ChartingCodeProvider codeConfig={template}>
			<Grid container spacing={3}>
				<Grid item xs="auto">
					<CodeLayoutTypeSelector template={template} />
				</Grid>

				<Grid item xs>
					<ChartingCodeDebug template={template} />
				</Grid>
			</Grid>

		</ChartingCodeProvider>
	);
};

export default CodeRenderer;
